/**
 * Brite:Bill namespace BBAPI
 * @namespace BBAPI
 */
var BBAPI = BBAPI || {};
/*var BBjQuery = function(){};

if(typeof jQuery === 'undefined') {
  console.log('ERROR: jQuery is undefined, Have you loaded jQuery?');
}else{
  var verNums = jQuery.fn.jquery.split('.');
  if (parseInt(verNums[0]) <= 1 && parseInt(verNums[1]) <= 8 && parseInt(verNums[2]) < 3) {
    console.log('jQuery version ' + jQuery.fn.jquery + ' is too old, Have you loaded jQuery version >= 1.8.3?');
  }else{
    //We are OK bbapi.js can run with a good version of jQuery.
    BBjQuery = jQuery.noConflict(true);
  }
}*/

//using BBjQuery as angular or $ may not be defined
jQuery(document).ready((function (BBAPI) {
  'use strict';
  BBAPI.selectorName = "#britebill-app";
  BBAPI.selector = jQuery(BBAPI.selectorName);
  BBAPI.config={userId:'SELF'};
  BBAPI.validConfig = [
    'apiBase',
    'cmsBase',
    'EncryptedToken',
    'fromReceiveDate',
    'userId',
    'appID',
    'timeoutUserSummary',
    'timeoutDocuments'
  ];

  /**
   * Set the application configuration
   * @function setConfig
   * @memberof BBAPI
   * @param {Object} config - Configuration object
   * @param {String} config.apiBase - The api endpoint to use can be absolute/relative or another domain (if cors is set)
   * @param {String} config.EncryptedToken - The EncryptedToken generated by Rogers
   * @param {String} config.fromReceiveDate - The recieve date of the user; skip attribute or set null value to return last 18 records
   * @param {String} config.userId - The UserID if needed by the CSR app or to generate a test token
   * @param {String} config.appID - The application id
   * @param {String} config.timeoutUserSummary - The timeout in ms to retrieve the activatedUserSummary from the ReST API
   * @param {String} config.timeoutDocuments - The timeout in ms to retrieve a users documents from the ReST API
   *
   */
  BBAPI.setConfig = function (config) {
    BBAPI.config = BBAPI.config || {};
    var p;
    for (p in config) {
      for (var i = 0; i < BBAPI.validConfig.length; i++) {
        if (BBAPI.validConfig[i] === p) {
          BBAPI.config[p] = config[p];
        }
      }
    }
  };

  /**
   * for getBillsForCurrentUser callbacks
   * @class getBillsForCurrentUser
   */
  /**
   * Get bills for the user identified by the encrypted token, passes the Array of bill references, for the current user
   * identified by EncryptedToken to the success callback: callBack. The bill references include the Bill ID and ReST
   * link to the actual bill data.
   * @function getBillsForCurrentUser
   * @memberof BBAPI
   * @param {String} EncryptedToken - Encrypted token
   * @param {getBillsForCurrentUser~callBack} callBack - Callback on success
   * @param {getBillsForCurrentUser~notActive} notActive - Callback on user not active
   * @param {getBillsForCurrentUser~errorHandler} errorHandler - Callback errorHandler
   *
   */
  BBAPI.getBillsForCurrentUser = function (EncryptedToken, callBack, notActive, errorHandler) {
    jQuery.support.cors = true;
    var data = {
      appID: BBAPI.config.appID || 'Rogers.com'
    };
    if (BBAPI.config.fromReceiveDate) {
      data.fromReceiveDate = BBAPI.config.fromReceiveDate;
    }
    data.uid = new Date().getTime();
    //UID to added to make sure new request is served instead of cache for IE browser
    var errorResponses = [
      "Error - there is no activation date specified as attribute for this customer.",
      "Error! Customer exist but nonactivated or invalid",
      "Error! Get user activate status failed",
      "Customer Not Registered"
    ];

    jQuery.ajax({
      type: 'GET',
      contentType: "text/plain",
      data: data,
      headers: {
        EncryptedToken: EncryptedToken,
        PUID: BBAPI.config.userId
      },
      url: BBAPI.config.apiBase + '/rogers/documents/activatedUserSummary',
      dataType: 'text',
      timeout: BBAPI.config.timeoutUserSummary || 5000,
      success: function (activatedUserSummary) {
        var i;
        var error = false;
        for (i = 0; i < errorResponses.length; i++) {
          if (errorResponses[i] === activatedUserSummary) {
            notActive(activatedUserSummary);
            error = true;
          }
        }
        if (!error) {
          activatedUserSummary = JSON.parse(activatedUserSummary);
          BBAPI.activatedUserSummary = activatedUserSummary.bills;
          BBAPI.brand=activatedUserSummary.brand||'rogers';
          BBAPI.brand=BBAPI.brand.toLowerCase();
          callBack(activatedUserSummary);
        }
      },
      //On standard error use errorHandler callback
      error: function (jqXHR, textStatus, errorThrown) {
        errorHandler(jqXHR, textStatus, errorThrown);
      }
    });
  };
  /**
   * Callback for success. Can be used to populate drop-down with array of bill references
   * @callback getBillsForCurrentUser~callBack
   * @param {Object} data - object with bill references
   * @param {String} data.activationDate - Activation date
   * @param {Array} data.bills - Array of bill references
   */

  /**
   * Callback for user not active, can fallback to old system
   * @callback getBillsForCurrentUser~notActive
   * @param {Array} data - Empty Array
   */

  /**
   * Callback for general errors, can handle network errors, logging etc.
   * @callback  getBillsForCurrentUser~errorHandler
   * @param {Object} jqXHR - jQuery XMLHttpRequest (See : https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest)
   * @param {String} jqXHR.readyState
   * @param {Number} jqXHR.status -  e.g.403,404
   * @param {String} jqXHR.statusText
   * @param {String} jqXHR.responseText
   * @param {function} jqXHR.getAllResponseHeaders()
   * @param {function} jqXHR.getResponseHeader()
   * @param {function} jqXHR.statusCode()
   * @param {function} jqXHR.abort()
   * @param {String} textStatus - Status e.g. 'timeout', 'error', 'abort', and 'parsererror'
   * @param {String} errorThrown - Textual portion of the HTTP status, such as "Not Found" or "Internal Server Error."
   */

  /**
   * for displayBill callbacks
   * @class displayBill
   */
  /**
   * Uses the encrypted token and Invoice ID/link to call the Brite:Bill Angular application, which then renders the
   * bill in the Brite:bill div. The function callbacks httpErrorHandler appErrorHandler will be invoked for the
   * relevant error cases
   * @function displayBill
   * @memberof BBAPI
   * @param {String} EncryptedToken - The encrypted user token to be used to authenticate calls to the BriteBill API
   * @param {String} link - The link to the document as returned by the getActivatedUserSummary() call e.g. "link": "documents/10-01398861307"
   * @param {displayBill~httpErrorHandler} httpErrorHandler - Callback httpErrorHandler
   * @param {displayBill~appErrorHandler} appErrorHandler - Callback appErrorHandler
   */
  BBAPI.displayBill = function (EncryptedToken, link, httpErrorHandler, appErrorHandler) {
    var InvoiceId = link;
    if (link.split('/')[0] === 'documents') {
      InvoiceId = link.split('/')[1];
    }
    BBAPI.config.EncryptedToken = EncryptedToken;
    BBAPI.InvoiceId = InvoiceId;
    BBAPI.httpErrorHandler = httpErrorHandler || function () {
    };
    BBAPI.appErrorHandler = appErrorHandler || function () {
    };
    window.location.href = "#/bill/" + InvoiceId;
  };
  /**
   * Callback for general errors, can handle network errors, logging etc.
   * @callback displayBill~httpErrorHandler
   * @param {Object} httpErrorObject - An object containing error details
   * @param {string|Object} httpErrorObject.data - The response body
   * @param {Number} httpErrorObject.status - HTTP status code of the response. e.g. 403/404/503 , defined in 'Valid ReST Responses V1-8.xlsx'
   * @param {Function({String})} httpErrorObject.headers - Header getter function httpErrorObject.headers([headerName]).
   * @param {String} httpErrorObject.headers.EncryptedToken - The encrypted token used in the request
   * @param {Object} httpErrorObject.config - Object of configuration
   * @param {String} httpErrorObject.statusText - HTTP status text of the response.
   *
   */
  /**
   * Callback for general errors, can handle network errors, logging etc.
   * @callback displayBill~appErrorHandler
   * @param {Object} appErrorObject - An object containing error details
   * @param {String} appErrorObject.data - English description
   * @param {number} appErrorObject.status - Error codes to be returned, defined in 'Valid Application Error Responses V1-8.xlsx'.
   *
   */
})(BBAPI));
